@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading && !isUiTest) {
  <div class="sideBarContent content">
    <irb-editor-sidebar-banner [accordian]="accordian" [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [showExpandControls]="false" [isModified]="isModified" [isValid]="hasUnapprovedTrades()" [hasPendingFunction]="hasPendingFunction"
      [slot]="slot" (save)="save()" saveLabel="Approve to Order Blotter" saveWarning="Unapproved Trades: You are about to leave without approving your trades."
      proceedButtonLabel="Proceed without approving" (cancel)="cancel()"><span header class="ms-header" tooltip [tooltipTitle]="slideOutTitle" [tooltipRequiresTruncation]="true">{{slideOutTitle}}</span>
    </irb-editor-sidebar-banner>
    <div class="body" [style.height]="bodyHeight" #body>
      <div class="editorDisplayBanner">
        <div class="block" style="background-color: #F0F0F0; border: 1px solid #999; padding: 10px;">
          <div class="dblock" style="display: flex; flex-direction: row; gap: 10px;">
            <div>
              <div class="hblock bold">Account Number</div>
              <irb-dropdown-search #accountNumberDropdown [(value)]="accountNumberTarget" (search)="getAccountNumbers($event)" [isRequired]="true" threshold="3"
              (selection)="setAccountNumberTarget($event)" (clearSelection)="clearAccountTarget()" size="15"></irb-dropdown-search>
            </div>
            <div>
              <div class="hblock bold">Account Name</div>
              <irb-dropdown-search #accountNameDropdown [(value)]="accountNameTarget" (search)="getAccountNames($event)" [isRequired]="true" threshold="3"
              (selection)="setAccountNameTarget($event)" (clearSelection)="clearAccountTarget()" size="40" hoverPanelWidth="400"></irb-dropdown-search>
            </div>
          </div>
          <div class="dblock" style="display: flex; flex-direction: row; gap: 10px;">
            <div>
              <div class="hblock bold">Symbol</div>
              <irb-dropdown-search #symbolDropdown [(value)]="symbolTarget" (search)="getSymbols($event)"
              (selection)="setSymbolTarget($event)" (clearSelection)="clearSymbolTarget()" [isRequired]="true" size="6"></irb-dropdown-search>
            </div>
            <div>
              <div class="hblock bold">Trans Type</div>
              <irb-dropdown-filter #transTypeDropdown [(value)]="transTypeTarget" (search)="getTransTypes($event)" [isRequired]="true"
              (selection)="setTransTypeTarget($event)" size="5" hoverPanelWidth="100"></irb-dropdown-filter>
            </div>
            <div>
              <div class="hblock bold">Dollar/Shares</div>
              <irb-dropdown-filter #denominationDropdown [(value)]="denominationTarget" (search)="getDenominations($event)" [isRequired]="!isSellAll" [disabled]="isSellAll"
              (selection)="setDenominationTarget($event)" size="6" hoverPanelWidth="100"></irb-dropdown-filter>
            </div>
            @if (!isDollars) {
              <div>
                <div class="hblock bold">Quantity</div>
                <irb-number-text-box #quantity [(value)]="trade.quantity" min="1" [disabled]="isSellAll" [places]="isMutualFundOrder ? 3 : 4"
                  [invalidRangeMessage]="isMutualFundOrder ? 'Please enter only numbers, with up to three decimal places.' : 'Please enter only numbers, with up to four decimal places.'"
                  invalidRequiredMessage="" isRequired="!isSellAll" (change)="validateTrade()"
                width="60px"></irb-number-text-box>
              </div>
            }
            @if (isDollars) {
              <div>
                <div class="hblock bold">Amount</div>
                <irb-number-text-box #dollarAmount [(value)]="trade.dollarAmount" min="1" [disabled]="isSellAll" places="2"
                  invalidRangeMessage="Please enter only numbers, with up to two decimal places."
                  invalidRequiredMessage="" [isCurrency]="true" isRequired="!isSellAll" (change)="validateTrade()"
                width="60px"></irb-number-text-box>
              </div>
            }
            <div>
              <div class="hblock bold">Order Type</div>
              <irb-dropdown-filter #orderTypeDropdown [(value)]="orderTypeTarget" (search)="getOrderTypes($event)" [disabled]="isMutualFundOrder" [isRequired]="!isMutualFundOrder"
              (selection)="setOrderTypeTarget($event)" size="6" hoverPanelWidth="100"></irb-dropdown-filter>
            </div>
            @if (trade.orderType == 'Limit' && trade.securitySymbol) {
              <div>
                <div class="hblock bold">Price Type</div>
                <irb-dropdown-filter #priceTypeDropdown  [(value)]="priceTypeTarget" (search)="getPriceTypes($event)" [isRequired]="true"
                (selection)="setPriceTypeTarget($event)" size="6" hoverPanelWidth="100"></irb-dropdown-filter>
              </div>
            }
            @if (trade.orderType == 'Limit' && trade.securitySymbol) {
              <div>
                <div class="hblock bold">Price</div>
                <irb-number-text-box #limitPrice [(value)]="trade.ordLimitPrice" min="1"
                  invalidRangeMessage="Please enter only numbers, with up to two decimal places." places="2"
                  invalidRequiredMessage="" isRequired="true" (change)="validateTrade()" width="60px"
                [isCurrency]="true" [disabled]="trade.orderType == 'Limit' && priceTypeTarget?.value != 'None'"></irb-number-text-box>
              </div>
            }
            @if (trade.orderType == 'Stop' && trade.securitySymbol) {
              <div>
                <div class="hblock bold">Price</div>
                <irb-number-text-box #stopPrice [(value)]="trade.ordStopPrice" min="1"
                  invalidRangeMessage="Please enter only numbers, with up to two decimal places." places="2"
                  invalidRequiredMessage="" isRequired="true" (change)="validateTrade()" width="60px"
                [isCurrency]="true"></irb-number-text-box>
              </div>
            }
            @if (trade.orderType == 'Market' && trade.securitySymbol) {
              <div>
                <div class="hblock bold">Price</div>
                <input pInputText type="text" [value]="'M'" disabled="disabled" [size]="5">
              </div>
            }
            @if (trade.orderType == 'Stop Limit' && trade.securitySymbol) {
              <div>
                <div class="hblock bold">Limit Price</div>
                <irb-number-text-box #limitPrice [(value)]="trade.ordLimitPrice" min="1" places="2"
                  invalidRangeMessage="Please enter only numbers, with up to two decimal places."
                  invalidRequiredMessage=""
                  isRequired="true" (change)="validateTrade()" width="50px"
                [isCurrency]="true"></irb-number-text-box>
              </div>
            }
            @if (trade.orderType == 'Stop Limit' && trade.securitySymbol) {
              <div>
                <div class="hblock bold">Stop Price</div>
                <irb-number-text-box #stopPrice [(value)]="trade.ordStopPrice" min="1" [maxConstraint]="trade.ordLimitPrice" places="2"
                  invalidRangeMessage="Please enter only numbers, with up to two decimal places."
                  invalidRequiredMessage="" invalidMaxConstraintMessage="Limit Price must be above or equal to the Stop Price"
                  isRequired="true" (change)="validateTrade()" width="50px"
                [isCurrency]="true"></irb-number-text-box>
              </div>
            }
            <div>
              <div class="hblock bold">Expiration Type</div>
              <irb-dropdown-filter #expirationTypeDropdown [(value)]="expirationTypeTarget" (search)="getExpirationTypes($event)" [disabled]="isMutualFundOrder || !this.trade.orderType" [isRequired]="!isMutualFundOrder"
              (selection)="setExpirationTypeTarget($event)" size="6" hoverPanelWidth="100"></irb-dropdown-filter>
            </div>
            @if (isExpirationDateEnabled) {
              <div>
                <div class="hblock bold">Expiration Date</div>
                <input pInputText #expirationDate="ngModel" class="expiration-date" type="date" [attr.min]="tomorrowDate"
                  [attr.max]="daySixMonthsAfter" [(ngModel)]="trade.expirationDate" required (change)="validateTrade($event)" (input)="validateTrade($event)">
              </div>
            }
            @if (!isExpirationDateEnabled) {
              <div>
                <div class="hblock bold">Expiration Date</div>
                <input pInputText [placeholder]="expirationDatePlaceholder" disabled="disabled" [size]="7" [value]="null">
              </div>
            }
          </div>
          <div style="display: flex; flex-direction: row; gap: 10px;">
            <div>
              <div class="hblock"><span class="bold">Trade Explanation</span> (Optional)</div>
              <div style="display: flex; flex-direction: row; gap: 10px;">
                <input (input)="validateTrade()" [(ngModel)]="trade.tradeExplanation" id="tradeExplanation" pInputText
                  type="text" style="width:400px" [maxlength]="255" />
                <div style="display: flex; flex-direction: row;">
                  <a class="irb-blue clickable" style="line-height: 24px;" (click)="clearTrade()">Clear</a>
                  <button class="btn-medium-primary" [disabled]="!isTradeValid" (click)="addTrade()">Add trade</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="block">
          <irb-inventory-grid
            [style.width] = "'100%'"
            [style.height] = "gridHeight"
            [style.minHeight] = "'240px'"
            [showSideBar] = "false"
            [gridOptions] = "gridOptions"
            componentName="qoe-grid"
            [frameworkComponents] = 'frameworkComponents'
            [rowData] = 'tradeList'
          (gridReady) = "onGridReady($event)"></irb-inventory-grid></div>

          <div class="buttonSet left">
            <button class="btn-large-primary btn-bottom" [disabled]="tradeList.length == 0 || !hasUnapprovedTrades()" (click)="save()">Approve to Order Blotter</button>
            <button class="btn-large-primary btn-bottom" [disabled]="tradeList.length == 0" (click)="removeAllTrades()">Clear</button>
            <button class="btn-large-secondary btn-bottom" (click)="cancel()">Cancel</button>
          </div>
          <br class="clear"/>
        </div>
      </div>
    </div>
  }